import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import "./Table.vue?vue&type=style&index=0&id=0fb292be&lang=sass"

const __exports__ = script;

export default __exports__